let initialState = {
  isLoading: true,
  isLoggedIn: false,
  user_id: null,
  user: null,
}

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_AUTH_PENDING":
      return {
        ...state,
        isLoading: true,
      }
    case "FETCH_AUTH_DONE":
      let { res, user, grouped_in } = action.payload
      let isLoggedIn = res == 1 && grouped_in == 1

      return {
        ...state,
        isLoading: false,
        isLoggedIn,
        user,
      }

    case "LOGOUT_FULFILLED":
      return {
        ...state,
        isLoading: false,
        isLoggedIn: false,
        user_id: null,
        user: null,
      }

    case "UPDATE_AUTH_COLUMN":
      let column = action.payload.column
      let column_val = action.payload.column_val
      return {
        ...state,
        details: {
          ...state.details,
          [column]: column_val,
        },
      }
    default:
      return state
  }
}

export default authReducer
